/**
 * This function is used to format the date, it takes the date object and returns a string in the format of "dd-mm-yyyy"
 * @param {date} date 
 * @returns string
 */
export function formatDate(date) {
    const today = new Date(date);
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    
    return dd + '/' + mm + '/' + yyyy;   
}

export function formatDateTime(dateString) {
  const dateObject = new Date(dateString);

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Use 24-hour format
  };

  let formattedDate = dateObject.toLocaleDateString('en-GB', options);

  const parts = formattedDate.split(', ');
  const [dayMonthYear, time] = parts;
  const [day, month, year] = dayMonthYear.split('/');
  const rearrangedDate = `${year}-${month}-${day} ${time}`;
  return rearrangedDate;
}


/**
 * Formats a date to exclude time information.
 *
 * @param {string | Date} value - The date value to format. It can be either a string or a Date object.
 * @returns {string} The formatted date without time information.
 */
export function formatDateWithoutTime(value) {
    let date = value instanceof Date ? value : new Date(value);

    if (date.toString() === "Invalid Date") {
        return "";
    } else {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    }

  }
  